import axios from "axios";
import end from './endpoint';
import auth from "./auth";
const ENDPOINT = end.PATH + "evidences/";

export default {
    get(period, partial, lesson) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + period + "/" + partial + "/" + lesson, { headers: { token } });
    },

    getOne(id) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + id, { headers: { token } });
    },

    getTotal(period, partial, lesson) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + "total/" + period + "/" + partial + "/" + lesson, { headers: { token } });
    },

    getBy(period, partial, date, lesson, type) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + period + "/" + partial + "/" + date + "/" + lesson + "/" + type, { headers: { token } });
    },

    insert(evidence) {
        const token = auth.getSession();
        return axios.post(ENDPOINT, evidence, { headers: { token } });
    },

    update(id, evidence) {
        const token = auth.getSession();
        return axios.put(ENDPOINT + id, evidence, { headers: { token } });
    },

    delete(id) {
        const token = auth.getSession();
        return axios.delete(ENDPOINT + id, { headers: { token } });
    },
};